var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view',{key:_vm.refreshKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }